// gen
const baseUrl = "https://mlxna.lizihulian.com.cn/api";
// dev
// const baseUrl = "http://malaixna.ubooking.cn/api";
export default {
  baseUrl
};



// WEBPACK FOOTER //
// ./src/global/constant.js